// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_pagination__3i9jO","current":"pagination_current__TncDw"};